export default {
  apiKey: 'AIzaSyCfuGRFgWl8Kj_18Kd94zlkH6o92E8OMQo',
  authDomain: 'ecgo-prod.firebaseapp.com',
  projectId: 'ecgo-prod',
  storageBucket: 'ecgo-prod.appspot.com',
  messagingSenderId: '873800987413',
  appId: '1:873800987413:web:c3cc90f9b825cc8163af1c',
  measurementId: 'G-J4J3L7N1BT',
};
